<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title>{{ `${$route.meta.title}` | t }}</v-toolbar-title>
            <v-spacer />
            <v-btn @click="submitEdit" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" />

        <!-- Main content -->
        <v-main>
            <v-overlay :value="loadingUserData">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <router-view />
        </v-main>

        <!-- Footer -->
        <page-footer />
        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>

        <!-- Error snackbar -->
        <v-snackbar color="error" bottom :timeout="2500" :value="requestError">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2 ">{{ errorMessage }}</div>
            </div>
        </v-snackbar>
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";

import { mapState } from "vuex";
import Store from "../store";

export default {
    components: {
        PageFooter,
        MainDrawer
    },
    data() {
        return {
            mainDrawerOpen: null
        };
    },
    mounted() {
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
    },
    destroyed() {
        Store.commit("UserStore/setRequestSuccess", false);
    },
    methods: {
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        submitEdit() {
            Store.dispatch("UserStore/submitUserUpdate", this.activeUser);
            if (this.activeUser.custom_links) {
                Store.commit("setUserCustomLinksData", this.activeUser.custom_links);
            }
        }
    },
    computed: {
        ...mapState("UserStore", [
            "drawerOpen",
            "requestSuccess",
            "requestError",
            "errorMessage",
            "activeUser",
            "loadingUserData"
        ])
    }
};
</script>

<style scoped>
.v-input__icon--prepend-inner .v-icon {
    margin-top: 0px !important;
}
</style>
